function FamilyEvent(props) {
  return <h2>Family Event</h2>;
}

export default FamilyEvent;
